export default "__VITE_PUBLIC_ASSET__1668af3d__"